// ABOUTME: Typed errors for the pennant API client so callers can distinguish
// ABOUTME: rate-limit, network, and server failures and react with tailored UX.

export const PENNANT_API_ERROR_KIND = Object.freeze({
    RATE_LIMIT: 'rate-limit',
    NETWORK: 'network',
    SERVER: 'server',
});

export class PennantApiError extends Error {
    constructor(kind, message, { status = null, cause = null } = {}) {
        super(message);
        this.name = 'PennantApiError';
        this.kind = kind;
        this.status = status;
        if (cause) this.cause = cause;
    }
}

export function classifyResponseError(response) {
    const status = response?.status ?? 0;
    if (status === 429) {
        return new PennantApiError(
            PENNANT_API_ERROR_KIND.RATE_LIMIT,
            `HTTP ${status}`,
            { status }
        );
    }
    return new PennantApiError(
        PENNANT_API_ERROR_KIND.SERVER,
        `HTTP ${status}`,
        { status }
    );
}

export function classifyFetchError(error) {
    return new PennantApiError(
        PENNANT_API_ERROR_KIND.NETWORK,
        error?.message || 'network error',
        { cause: error }
    );
}
